import { registerPlugin } from '@capacitor/core';
import '@solitics/solitics-web-sdk';
const SoliticsBridge = registerPlugin('SoliticsBridge', {
    web: () => import('./web').then((m) => new m.SoliticsBridgeWeb()),
});
export default SoliticsBridge;
